import React from "react"
import connect from "./connect"
import {Container, StyledTitle} from "./components"
import {FacetState} from "../../models/FacetsState"
import Chips from "../searchBanner/chips"
import {Content} from "../searchBanner/templatedSearchBanner/models"
import {IChip} from "../searchBanner/chips/models"

/* This has  a cypress test that might need updating */

type StructuredBrowsingChipsProps = {
    enableStructuredBrowsing: boolean
    facets: FacetState[]
    siteUrl: string
    show: boolean
    titleText: string
}

export const StructuredBrowsingChips = ({
    enableStructuredBrowsing,
    facets,
    siteUrl,
    show,
    titleText,
}: StructuredBrowsingChipsProps) => {
    if (!enableStructuredBrowsing || (facets.length > 0 && facets[0].u === undefined) || facets.length === 0)
        return null

    const components: IChip[] = facets.map(facet => {
        const {u, n} = facet
        return {
            url: `${siteUrl}${u as string}`,
            text: n,
            accessibilityText: n,
            openInNewWindow: false,
        }
    })

    const myContent: Content<"chips"> = {
        text: "",
        regionTitle: `${titleText}`,
        components,
    }
    return (
        <Container $show={show}>
            <StyledTitle variant="subtitle1">{titleText}</StyledTitle>
            <Chips overrideStyles={{}} content={myContent} isStructuredBrowsingChip isIntelRecs={false} />
        </Container>
    )
}

export default connect(StructuredBrowsingChips)
